import React from "react";
import { DictionaryType } from "../../constants";

/** Lista obu typów wpisów z kolumnami wynikającymi z definicji. */
export default function DictionaryEntries({
  definition,
  entries,
  editable,
  disabled,
  onEdit,
  onRemove,
}) {
  const record = definition.type === DictionaryType.RECORD;
  const columns = record
    ? definition.fields
    : [{ key: "value", label: definition.valueLabel }];
  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>{definition.keyLabel}</th>
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
            {editable && (
              <th>
                <span className="visually-hidden">Akcje</span>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {entries.map((entry) => (
            <tr key={entry.key}>
              <td>{entry.key}</td>
              {columns.map((column) => (
                <td key={column.key} style={{ whiteSpace: "pre-line" }}>
                  {record ? entry.value[column.key] : entry.value}
                </td>
              ))}
              {editable && (
                <td className="text-end">
                  <div className="premium-button-group justify-content-end">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      disabled={disabled}
                      onClick={() => onEdit(entry)}
                    >
                      Edytuj
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      disabled={disabled}
                      onClick={() => onRemove(entry)}
                    >
                      Usuń
                    </button>
                  </div>
                </td>
              )}
            </tr>
          ))}
          {!entries.length && (
            <tr>
              <td colSpan={1 + columns.length + Number(editable)}>
                Brak wpisów.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
